<template>
    <div class="footer-desktop__wrapper has-bottom" v-if="isShow">
        <!-- <div :class="{ 'footer-desktop__desc-wrapper': !isMobile }">
      <div
        :class="{
          container: !isMobile,
          'footer-mobile__desc-wrapper': isMobile,
          'display-flex-sb': currentLocale !== 'th' && currentLocale !== 'vn',
        }"
        style="align-items: baseline"
      >
        <div class="footer-link__wrapper" v-if="currentLocale === 'vn'">
          <div
            class="footer-link"
            v-for="article in footerLinks"
            :key="article.id"
          >
            <router-link
              :to="{ path: encodeURI(`/${currentLocale}/${article.url}`) }"
              >{{ article.linkText }}</router-link
            >
          </div>
        </div>
        <div
          class="footer-desktop__desc-container"
          v-else-if="currentLocale !== 'th' && currentLocale != 'vn'"
        >
          <h2 class="footer-desktop__desc-title" v-if="currentLocale === 'th'">
            {{ $t("FOOTER_DESCRIPTION_TITLE") }}
          </h2>
          <h2 class="footer-desktop__desc-title" v-else></h2>
          <p class="footer-desktop__desc-content">
            {{ $t("FOOTER_DESCRIPTION_CONTENT") }}
          </p>
        </div>
        <div class="footer-desktop__desc-container" v-if="!isMobile">
          <h2 class="footer-desktop__desc-title">
            {{ $t("FOOTER_DISCLAIMER_TITLE") }}
          </h2>
          <p class="footer-desktop__desc-content">
            {{ $t("FOOTER_DISCLAIMER_CONTENT") }}
          </p>
        </div>
      </div>
    </div> -->
        <!-- <div class="footer-mobile__desc-wrapper" v-if="isMobile">
      <div class="container display-flex-sb" style="align-items: baseline">
        <div class="footer-mobile__desc-container">
          <h2 class="footer-desktop__desc-title">
            {{ $t("FOOTER_DISCLAIMER_TITLE") }}
          </h2>
          <p class="footer-desktop__desc-content">
            {{ $t("FOOTER_DISCLAIMER_CONTENT") }}
          </p>
        </div>
      </div>
    </div>
    <div
      v-if="isMobile"
      class="footer-mobile__desc-wrapper footer-mobile__privacy-wrapper"
    >
      <div class="footer-mobile__privacy">
        <router-link :to="{ name: 'privacypolicy' }">{{
          $t("PRIVACY_POLICY")
        }}</router-link>
      </div>
      <p class="footer-mobile__copyright">
        © {{ currentYear }} {{ $t("COPYRIGHT_CONTENT") }}
      </p>
    </div> -->

        <div class="footer-desktop__social-wrapper full-screen-width">
            <div class="container">
                <div>
                    <MainLogo class="mr-2rem home-logo footer-logo"></MainLogo>
                    <div class="footer-desc">
                        {{ $t("FOOTER_DESC") }}
                    </div>
                    <div class="footer-content">
                        {{ $t("FOOTER_CONTENT", { year: currentYear }) }}
                    </div>
                    <div class="footer-download-icon-list">
                        <div class="footer-download-icon">
                            <template
                                v-if="displayHeaderDownloadIcon && !isMobile"
                            >
                                <DownloadIconList />
                            </template>
                        </div>
                    </div>

                    <div class="display-flex-sb">
                        <div class="footer-desktop__copy-right">
                            <p class="font-m">
                                {{
                                    $t("COPYRIGHT_CONTENT", {
                                        year: currentYear,
                                    })
                                }}
                            </p>
                        </div>
                        <div class="footer-desktop__social-container">
                            <!-- <a
                                :href="$t('FB')"
                                target="_blank"
                                class="footer-desktop__social-icon hover-grow"
                            >
                                <SvgIcon icon="footer.social.fb" />
                            </a>
                            <a
                                :href="$t('IG')"
                                target="_blank"
                                class="footer-desktop__social-icon hover-grow"
                            >
                                <SvgIcon icon="footer.social.ig" />
                            </a> -->

                            <a
                                href="mailto:support@asiasports.com"
                                target="_blank"
                                class="footer-desktop__social-icon hover-grow"
                            >
                                <SvgIcon icon="footer.social.email" />
                            </a>
                        </div>
                    </div>
                    <!-- <div>
            <router-link
              :to="{ name: 'privacypolicy' }"
              class="font-m footer-desktop__privacy"
              >{{ $t("PRIVACY_POLICY") }}</router-link
            >
          </div> -->
                </div>
            </div>
        </div>
    </div>
    <div class="footer-wrapper" v-if="isShow">
        <ul class="footer-container">
            <template v-for="(o, index) in footerTabs" :key="index">
                <div
                    class="footer-icon__wrapper"
                    :class="{ selected: o.selected }"
                    v-if="o.display !== false"
                >
                    <div
                        v-if="o.id !== 9"
                        class="relative"
                        @click="toggleFooter(o)"
                    >
                        <!-- <template v-if=""> -->

                        <div
                            :class="[
                                `footer-icon__container footer-icon__${o.id}`,
                                {
                                    dark: themeMode === 'dark',
                                    selected: o.selected,
                                },
                            ]"
                        ></div>
                        <span>{{ $t(o.name) }}</span>
                        <div v-if="o.isLive" class="dot-wrapper">
                            <div class="ripple"></div>
                        </div>
                        <!-- </template> -->
                    </div>
                    <!-- <div v-else class="footer-icon__fifa">
            <div class="relative" @click="toggleFifaFooter(o)">
              <div class="footer-icon__fifa-fake"></div>
              <div class="footer-icon__fifa-fake2"></div>
              <div
                v-if="isShowSportTypeOption"
                class="footer-icon__fifa-img selected"
              ></div>
              <div
                v-else
                :class="`footer-icon__fifa-img ${this.currentSportType}`"
              ></div>
            </div>
            <div
              v-show="isShowSportTypeOption"
              class="footer-sport-type__wrapper"
            >
              <img
                v-for="(o, index) in sportType"
                :key="index"
                @click="handleFooterSportType(o)"
                class="footer-sport-type__icon"
                :src="
                  require(`../../static/images/icons/icon_footer_${o.name}.png`)
                "
              />
            </div>
          </div> -->
                </div>
            </template>
        </ul>
    </div>
    <PopUpSignInIndexMobile
        ref="PopUpSignInIndexMobileRef"
        :pathName="`/${currentLocale}/signin`"
        :message="$i18n.t('FAV_LOGIN_TIPS')"
        :title="$i18n.t('FAV_LOGIN_TITLE')"
    ></PopUpSignInIndexMobile>
</template>

<script>
import { mapGetters, mapMutations, mapActions, mapState } from "vuex";
import MainLogo from "@/components/indicator/MainLogo.vue";
import articles from "@/js/seoArticles/footer.js";
import PopUpSignInIndexMobile from "@/components/user/PopUpSignInIndexMobile.vue";
import FooterMenuIcon from "@/components/ui/FooterMenuIcon.vue";
import DownloadIconList from "@/components/socialMediaSharing/DownloadIconList.vue";
import config from "../js/config";

export default {
    components: {
        MainLogo,
        FooterMenuIcon,
        PopUpSignInIndexMobile,
        DownloadIconList,
    },
    computed: {
        ...mapState(["themeMode"]),
        ...mapGetters([
            "currentLocale",
            "currentSportType",
            "footerTabs",
            "isMobile",
            "isLogin",
        ]),
    },
    watch: {
        currentLocale: {
            deep: true,
            handler(newVal, oldVal) {
                this.getTiktokLink();
                this.getFooterArticleLinks();
            },
        },
    },
    data() {
        return {
            displayHeaderDownloadIcon: config.headerDownloadIcon,
            isRefreshing: false,
            footerLinks: null,
            currentYear: new Date().getFullYear(),
            isShow: true,
            targetRouteName: ["signup", "signin", "forgetpassword"],
            isShowTiktok: false,
            isShowSportTypeOption: false,
            sportType: [
                {
                    name: "football",
                    isSelect: false,
                },
                {
                    name: "basketball",
                    isSelect: false,
                },
            ],
        };
    },
    mounted() {
        this.getFooterArticleLinks();
        this.setDisplayStatus();
    },
    methods: {
        ...mapActions(["refresh", "defineSportType"]),
        ...mapMutations(["CURRENT_SUB_NAVI_MENU_CHANGE"]),

        setDisplayStatus() {
            if (
                this.isMobile &&
                this.targetRouteName.includes(this.$route.name)
            ) {
                this.isShow = false;
            }
        },

        handleRefresh() {
            this.isRefreshing = true;
            setTimeout(() => (this.isRefreshing = false), 500);

            //this.$router.go()
            //location.reload();
            this.refresh();
        },

        getTiktokLink() {
            const tiktokLink = {
                vn: "https://www.tiktok.com/@asiasports.vn",
                th: "https://www.tiktok.com/@asiasports.thai",
                kh: "https://www.tiktok.com/@asiasports.kh",
            };
            this.isShowTiktok = tiktokLink[this.currentLocale];
            return tiktokLink[this.currentLocale];
        },

        getFooterArticleLinks() {
            if (typeof articles[this.currentLocale] !== "undefined") {
                this.footerLinks = articles[this.currentLocale];
            }
        },
        toggleFifaFooter(o) {
            this.isShowSportTypeOption = !this.isShowSportTypeOption;
            o.selected = !o.selected;
        },
        handleFooterSportType(o) {
            const whiteListPage = ["news", "notification"];
            const whiteListChangePage = [
                "home",
                "highlight",
                "favourite",
                "fantasysport",
            ];
            let fullPath = window.location.pathname.split("/");

            let routeName = this.$route.meta.name;

            if (whiteListPage.includes(fullPath[2])) {
                this.defineSportType(o.name);
            } else if (whiteListChangePage.includes(routeName)) {
                fullPath[2] = o.name;
                this.$router.replace(
                    fullPath.join("/") + window.location.search
                );
            } else {
                if (this.currentSportType !== o.name) {
                    this.$router.push(`/${o.name}/matches`);
                }
            }

            this.isShowSportTypeOption = !this.isShowSportTypeOption;
        },
        toggleFooter(o) {
            if (o.name === "FANTASY") {
                if (this.isLogin) {
                    this.$router.push({
                        path: `/${this.currentLocale}/${this.currentSportType}/${o.pathOnly}`,
                    });
                    this.isShowSportTypeOption = false;
                    setTimeout(() => {
                        o.selected = !o.selected;
                    }, 300);
                } else {
                    this.$refs.PopUpSignInIndexMobileRef.handleOpen();
                }
            } else {
                // let isSportType = ['football','basketball']
                // let sportType = isSportType.includes(this.currentSportType) ? this.currentSportType : 'football'
                if (o.id === 1) {
                    sessionStorage.removeItem("calendarDate");
                    this.$router.push({
                        path: `/${this.currentLocale}${o.path}`,
                    });
                } else if (o.id === 2) {
                    if (this.isLogin && o.isLogin) {
                        this.$router.push({
                            path: `/${this.currentLocale}${o.path}`,
                        });
                    } else {
                        this.$refs.PopUpSignInIndexMobileRef.handleOpen();
                    }
                } else if (o.id === 3) {
                    //news
                    this.$router.push({
                        path: `/${this.currentLocale}/${o.pathOnly}`,
                    });
                } else if (o.id === 4) {
                    // more
                    this.$router.push({
                        path: `/${this.currentLocale}/${o.pathOnly}`,
                    });
                } else {
                    this.$router.push({
                        path: `/${this.currentLocale}/${this.sportType}/${o.pathOnly}`,
                    });
                }
                this.isShowSportTypeOption = false;
                // setTimeout(() => {
                //     o.selected = !o.selected;
                // }, 300);
            }
        },
    },
};
</script>

<style>
@-moz-keyframes spin {
    100% {
        -moz-transform: rotate(360deg);
    }
}
@-webkit-keyframes spin {
    100% {
        -webkit-transform: rotate(360deg);
    }
}
@keyframes spin {
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}
.footer-refresh {
    -webkit-animation: spin 2s linear infinite;
    -moz-animation: spin 2s linear infinite;
    animation: spin 0.8s linear infinite;
}
.footer-desktop__desc-wrapper {
    background-color: rgb(0 0 0);
    border-top: 0.1rem solid #35454d;
    border-bottom: 0.1rem solid #35454d;
}
.footer-desktop__desc-container {
    width: 48.5%;
}
.footer-desktop__desc-title {
    font-size: 11.2px;
    margin: 1rem 0;
    color: var(--color-grey-light);
}
.footer-desktop__desc-content {
    font-size: 10px;
    color: var(--color-theme-2);
    margin-bottom: 1rem;
}
.footer-link__wrapper {
    display: flex;
    margin-top: 1rem;
}
.footer-link {
    padding-right: 3rem;
}
.footer-link a {
    font-size: 0.688rem;
    color: var(--color-grey-80);
}
.footer-link a:hover {
    color: var(--color-grey-light);
    text-decoration: underline;
}
.footer-desktop__social-wrapper {
    padding: 48px 0 32px;
    background-color: var(--color-background-default-secondary);
}
.footer-desktop__social-container {
    display: flex;
    margin-right: 3rem;
}
.footer-desktop__copy-right {
    margin-right: 3.5rem;
    color: var(--color-text-default-default);
}
.footer-desktop__social-icon {
    cursor: pointer;
    padding: 0 0.75rem;
    width: 1.5rem;
    height: 1.5rem;
}
.footer-desktop__social-icon img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
.footer-desktop__wrapper {
    position: relative;
}
.footer-desktop__privacy:hover {
    text-decoration: underline;
}
.footer-wrapper {
    display: none;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 3;
    background-color: var(--color-background-default-secondary);
    /* border-top: 0.1rem solid #35454d; */
    box-shadow: 0 0 7px rgba(0, 0, 0, 0.3);
}
.footer-container {
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    margin: 0.5rem 0 0.8rem 0;
}
.footer-icon__wrapper {
    -webkit-flex: 1;
    flex: 1;
    -webkit-box-flex: 1;
    -moz-box-flex: 1;
    -ms-flex: 1;
    color: var(--color-text-default-tertiary);
    font-size: 11.2px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    font-family: var(--weight-600);
}
.footer-icon__container {
    display: block;
    margin: 0 auto;
    width: 1.5rem;
    height: 1.5rem;
    transition: all.5s;
    margin-bottom: 0.2rem;
}
.footer-icon__wrapper.selected {
    color: var(--color-text-default-default);
}

.footer-icon__1.selected,
.footer-icon__1.dark.selected {
    animation: nimateBall 0.5s ease forwards;
}

.footer-icon__1 {
    background: url(../../static/images/icons/aspn_icon/icon_score.png)
        center/contain no-repeat;
}
.footer-icon__1.dark {
    background: url(../../static/images/icons/aspn_icon/icon_score_dark.png)
        center/contain no-repeat;
}
.footer-icon__1.selected {
    background: url(../../static/images/icons/aspn_icon/icon_score_selected.png)
        center/contain no-repeat;
}
.footer-icon__1.dark.selected {
    background: url(../../static/images/icons/aspn_icon/icon_score_selected_dark.png)
        center/contain no-repeat;
}

.footer-icon__2 {
    background: url(../../static/images/icons/aspn_icon/icon_favourite_footer.png)
        center/contain no-repeat;
}
.footer-icon__2.dark {
    background: url(../../static/images/icons/aspn_icon/icon_favourite_disabled.png)
        center/contain no-repeat;
}
.footer-icon__2.selected {
    background: url(../../static/images/icons/aspn_icon/icon_favourite_footer_selected.png)
        center/contain no-repeat;
}
.footer-icon__2.dark.selected {
    background: url(../../static/images/icons/aspn_icon/icon_favourite_footer_selected_dark.png)
        center/contain no-repeat;
}

.footer-icon__3 {
    background: url(../../static/images/icons/aspn_icon/icon_news.png)
        center/contain no-repeat;
}
.footer-icon__3.dark {
    background: url(../../static/images/icons/aspn_icon/icon_news_dark.png)
        center/contain no-repeat;
}
.footer-icon__3.selected {
    background: url(../../static/images/icons/aspn_icon/icon_news_selected.png)
        center/contain no-repeat;
}
.footer-icon__3.dark.selected {
    background: url(../../static/images/icons/aspn_icon/icon_news_selected_dark.png)
        center/contain no-repeat;
}

.footer-icon__4 {
    background: url(../../static/images/icons/aspn_icon/icon_more.png)
        center/contain no-repeat;
}
.footer-icon__4.dark {
    background: url(../../static/images/icons/aspn_icon/icon_more_dark.png)
        center/contain no-repeat;
}
.footer-icon__4.selected {
    background: url(../../static/images/icons/aspn_icon/icon_more_selected.png)
        center/contain no-repeat;
}
.footer-icon__4.dark.selected {
    background: url(../../static/images/icons/aspn_icon/icon_more_selected_dark.png)
        center/contain no-repeat;
}

/* 
.selected .footer-icon__1 {
  animation: nimateBall 0.5s ease forwards;
  -webkit-animation: nimateBall 0.5s ease forwards;
  background: url(../../static/images/icons/aspn_icon/icon_score_selected.png)
    center/contain no-repeat;
}
.footer-icon__2 {
  background: url(../../static/images/icons/aspn_icon/icon_favourite.png)
    center/contain no-repeat;
}
.selected .footer-icon__2 {
  animation: nimateBall 0.5s ease forwards;
  -webkit-animation: nimateBall 0.5s ease forwards;
  background: url(../../static/images/icons/aspn_icon/icon_favourite_footer_selected.png)
    center/contain no-repeat;
}
.footer-icon__3 {
  background: url(../../static/images/icons/aspn_icon/icon_news.png)
    center/contain no-repeat;
}
.selected .footer-icon__3 {
  animation: nimateBall 0.5s ease forwards;
  -webkit-animation: nimateBall 0.5s ease forwards;
  background: url(../../static/images/icons/aspn_icon/icon_news_selected.png)
    center/contain no-repeat;
}
.footer-icon__4 {
  background: url(../../static/images/icons/aspn_icon/icon_more.png)
    center/contain no-repeat;
}
.selected .footer-icon__4 {
  animation: nimateBall 0.5s ease forwards;
  -webkit-animation: nimateBall 0.5s ease forwards;
  background: url(../../static/images/icons/aspn_icon/icon_more_selected.png)
    center/contain no-repeat;
} */
.footer-icon__8 {
    background: url(../../static/images/icons/icon_footer_fantacy_1_unselect.png)
        center/contain no-repeat;
}
.selected .footer-icon__8 {
    animation: nimateBall 0.5s ease forwards;
    -webkit-animation: nimateBall 0.5s ease forwards;
    background: url(../../static/images/icons/icon_footer_fantacy_1_selected.png)
        center/contain no-repeat;
}

.selected .footer-icon__fifa-img {
    animation: nimateBall 0.5s ease forwards;
    -webkit-animation: nimateBall 0.5s ease forwards;
    background: url(../../static/images/icons/icon_footer_close.png)
        center/contain no-repeat;
}
.footer-icon__fifa-img {
    background: url(../../static/images/icons/icon_footer_sport_football_selected.png)
        center/contain no-repeat;
}
.footer-icon__fifa-img.football {
    background: url(../../static/images/icons/icon_footer_sport_football_selected.png)
        center/contain no-repeat;
}
.footer-icon__fifa-img.basketball {
    background: url(../../static/images/icons/icon_footer_sport_basketball_selected.png)
        center/contain no-repeat;
}
.footer-icon__hkfs-img {
    background: url(../../static/images/icons/icon_footer_fantasy_unselect.png)
        center/contain no-repeat;
}
.selected .footer-icon__hkfs-img {
    animation: nimateBall 0.5s ease forwards;
    -webkit-animation: nimateBall 0.5s ease forwards;
    background: url(../../static/images/icons/icon_footer_hkfs_selected.png)
        center/contain no-repeat;
}
/* .footer-icon__4{
        background: url(../../static/images/icons/icon_footer_notification_unselect.png) center/cover no-repeat;
        background-size: inherit;
    }
    .router-link-active  .footer-icon__4{
        animation: nimateBall .5s ease forwards;
        -webkit-animation: nimateBall .5s ease forwards;
        background: url(../../static/images/icons/icon_footer_notification_unselect.png) center/cover no-repeat;
        background-size: inherit;
    } */

.footer-icon__5 {
    background: url(../../static/images/icons/icon_footer_refresh.png)
        center/contain no-repeat;
    background-size: inherit;
}
.router-link-active .footer-icon__5 {
    animation: nimateBall 0.5s ease forwards;
    -webkit-animation: nimateBall 0.5s ease forwards;
    background: url(../../static/images/icons/icon_footer_more_unselect.png)
        center/contain no-repeat;
    background-size: inherit;
}
.footer-icon__wrapper .dot-wrapper {
    top: -0.3rem;
    right: 0.3rem;
}
.footer-icon__fifa {
    position: absolute;
    top: -14px;
    right: 81%;
}
.footer-icon__fifa-fake {
    width: 58px;
    height: 58px;
    position: absolute;
    border-radius: 50%;
    z-index: 10;
    left: -5px;
    top: -2px;
    background-color: #000000;
    border: 0.1rem solid #35454d;
}
.footer-icon__fifa-fake2 {
    width: 64px;
    height: 69px;
    position: absolute;
    background-color: #020611;
    z-index: 123;
    top: 6.8px;
    left: -5px;
}
.footer-icon__fifa-img {
    z-index: 123;
    position: absolute;
    left: -3px;
    width: 57px;
    display: block;
    height: 57px;
}

.footer-sport-type__wrapper {
    position: absolute;
    top: -4rem;
    left: -41px;
    border-radius: 1rem;
    display: flex;
}
.footer-sport-type__icon {
    width: 55px;
    height: 55px;
    margin: 0 0.5rem;
}
@media(max-width: 768px) {
    /* for test */
    .footer-desktop__wrapper {
        display: none;
    }
    .footer-desktop__social-wrapper {
        display: none;
    }
    .footer-desktop__desc-container {
        width: auto;
        padding: 0 0.8rem 1.5rem 0.8rem;
    }
    .footer-desktop__desc-wrapper {
        border-bottom: none;
    }
    .footer-link__wrapper {
        flex-wrap: wrap;
        margin: 1rem 0;
    }
    .footer-link {
        padding-right: 1.5rem;
    }
    .footer-mobile__desc-wrapper {
        margin: 0 0.8rem;
        border-top: 0.1rem solid #35454d;
    }
    .footer-mobile__desc-container {
        width: auto;
    }
    .footer-wrapper {
        display: block;
    }
    .footer-mobile__privacy {
        font-size: 0.6875rem;

        margin-bottom: 0.5rem;
    }
    .footer-mobile__privacy a {
        color: var(--bg-selected);
    }
    .footer-mobile__privacy-wrapper {
        padding: 1rem 0;
    }
    .footer-mobile__copyright {
        color: #5c7784;
        font-size: 0.6875rem;
    }
}
</style>

<style scoped>
.footer-logo {
    width: 154px;
    /* width: inherit; */
    margin-left: 0;
    margin-bottom: 0;
}
.footer-desc {
    font-size: 24px;
    font-family: var(--weight-600);
    letter-spacing: -0.48px;
    color: var(--color-text-default-default);
    padding: 24px 0 24px;
    letter-spacing: -0.64px;
}
.footer-content {
    color: var(--color-text-default-default);
    font-size: 20px;
    margin-bottom: 0;
}
.footer-download-icon {
    width: 147px;
    padding-top: 24px;
}
.footer-download-icon-list {
    width: 100%;
    border-bottom: 1px solid var(--color-border-default-default);
    padding-bottom: 32px;
    margin-bottom: 33px;
}
</style>

<style>
.footer-logo {
    height: 63px;
}
.footer-logo img {
    height: 63px;
}
</style>
